import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Form, Input } from "semantic-ui-react";
import * as yup from "yup";
import { producaov2 as api } from "../../../../services/apis";

import {
  Container,
  Content, Title
} from "./styles";

import { withRouter } from "react-router-dom";
import swal from "sweetalert";
import Dropzone from "../../../../components/Admin/Dropzone";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { getToken, isAuthAdmin } from "../../../../services/auth";

const EditarConsultor = (props) => {
  const [loading, setLoading] = useState(false);
  const [selectedFileFoto, setSelectedFileFoto] = useState("");
  const [selectedFileFotoMobile, setSelectedFileFotoMobile] = useState("");
  const[data,setData]= useState({
    url: "",
    url_image: "",
    url_image_mobile: "",
    alt_image: "",
    title_campaign: "",
    active: 1,
  })

  useEffect(() => {
      loadAuth();
  }, []);
  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };


  const uploadImageFoto = async ({isMobile}) => {
    try {
      const inputData = new FormData();

      console.log("entrou aq",selectedFileFotoMobile)

      if(isMobile){
        selectedFileFotoMobile.originalname = selectedFileFotoMobile.name
        inputData.append("file", selectedFileFotoMobile);
        inputData.append("path", "campaign/upload-admin");
      }else {
        selectedFileFoto.originalname = selectedFileFoto.name
        inputData.append("file", selectedFileFoto);
        inputData.append("path", "campaign/upload-admin");
      }

      const response = await api.post("/upload", inputData);
      const { url } = response.data;

      if(isMobile){
        setData({ ...data, url_image_mobile: url });

      }else{
        setData({ ...data, url_image: url });

      }


      toast.success("A operação foi concluida com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      toast.error("A operação falhou, verifique o arquivo e tente novamente", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };
  const create = async () => {
    // const consultorValidation = await yup.object().shape({
    //   nome: yup
    //     .string("Necessário que informe o nome do consultor")
    //     .required("Necessário que informe o nome do consultor"),
    //   curriculo: yup
    //     .string("Necessário que informe o curriculo")
    //     .required("Necessário que informe o curriculo"),
    //   seg: yup
    //     .string("Necessário que informe o segmento")
    //     .required("Necessário que informe o segmento"),
    //   sexo: yup
    //     .string("Necessário que informe o sexo")
    //     .required("Necessário que informe o sexo"),
    // });

    try {
      // await consultorValidation.validate(data, { abortEarly: true });

      await api.post(`/admin/campaign`, data);

      // await systemLogs("consultor", `editou o consultor de id=${id}`);

      props.history.push("/admin/campaign", {
        headers: {
          access_token: `voitto-token ${getToken()}`,
        }
        },
);
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }

      // swal("Não foi possível salvar o consultor", err, "").then(() =>
      //   props.history.push("/admin/consultores")
      // );
    }
  };

  if(!loading) {
    return (
      <>
        <Container>
          <AdminMenu />

          <Content>
            <Title>Criar Campanha</Title>

            <Form>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Status: (checked: ativo | unchecked: inativo) "
                  placeholder="status: 1 ativo 0 Inativo"
                  style={{
                    width: "fit-content",
                    marginLeft: 0
                  }}
                  type="checkbox"
                  checked={data.active}
                  value={data.active}
                  onChange={(e) => {
                    setData({ ...data, active: e.target.value ? 1 : 0 });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Title:"
                  placeholder="Titulo da campanha..."
                  value={data.title_campaign}
                  onChange={(e) => {
                    setData({ ...data, title_campaign: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="url:"
                  placeholder="Url da campanha"
                  value={data.url}
                  onChange={(e) => {
                    setData({ ...data, url: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Texto descritivo da Imagem:"
                  placeholder="Descreva a imagem"
                  value={data.alt_image}
                  onChange={(e) => {
                    setData({ ...data, alt_image: e.target.value});
                  }}
                />
              </Form.Group>
              <Form.Group>
                <Form.Field>
                  <label>imagem Desktop:</label>
                  <Dropzone onFileUploaded={setSelectedFileFoto} selectFile={selectedFileFoto}/>
                </Form.Field>
              </Form.Group>
              <Form.Field>
                <Button color="primary" onClick={() => uploadImageFoto(false)}>
                  Subir imagem
                </Button>
              </Form.Field>
              <Form.Group>
                <Form.Field>
                  <label>imagem Mobile:</label>
                  <Dropzone onFileUploaded={setSelectedFileFotoMobile} selectFile={selectedFileFotoMobile}/>
                </Form.Field>
              </Form.Group>
              <Form.Field>
                <Button color="primary" onClick={() => uploadImageFoto(true)}>
                  Subir imagem
                </Button>
              </Form.Field>
              <Form.Group>
                <Form.Field control={Button} onClick={() => create()}>
                  Criar campanha
                </Form.Field>
              </Form.Group>
            </Form>
          </Content>
        </Container>
      </>
    );
  }
  return<></>;
};

export default withRouter(EditarConsultor);
